import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Store } from "@ngrx/store";
import { NavParams, ViewController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { ClientData } from "../../../../../../providers/client";
import { GenFormBuilder } from "../../../../../../providers/form";
import { Utilities } from "../../../../../../providers/utilities";
import { IClient } from "../../../../../../shared/models/client.model";
import * as sharedSelectors from "../../../../../../shared/reducers/shared.reducer";

@Component({
  selector: "business-agenda-form",
  templateUrl: "business-agenda-form.html",
})
export class BusinessAgendaFormComponent implements OnInit, OnDestroy {

  public form: FormGroup;
  public submitAttempt: boolean = false;
  public clientId: string;
  public client: IClient;
  public business: any;
  public formList$: Observable<any[]>;
  public clientSubscribe: Subscription;
  public defaultLanguage: string;
  public language: string;
  public firstLoad: boolean = true;
  public languageMenu: "en" | "es" = "es";

  constructor(
    private formBuilder: FormBuilder,
    private genForm: GenFormBuilder,
    private utilities: Utilities,
    private navParams: NavParams,
    private clientData: ClientData,
    private store: Store<{}>,
    public viewCtrl: ViewController,
  ) { }

  public ngOnInit() {
    this.clientId = this.navParams.get("clientId");
    this.business = this.navParams.get("business");
    this.formList$ = this.clientData.getClientFormUsers(this.clientId);
    this.clientSubscribe = this.store.select(sharedSelectors.getClient).subscribe((client) => {
      if (client) {
        this.client = client;
        this.defaultLanguage = client.defaultLanguage;
        this.language = this.defaultLanguage;
        this.buildForm();
      }
    });
  }

  public onFormSubmitted({ value, valid }: { value: any; valid: boolean }) {
    this.submitAttempt = true;
    if (valid) {
      const load = this.utilities.setLoading();
      this.clientData.createBusinessAgendaForm(this.clientId, value)
        .then(() => {
          this.utilities.Toast.create({
            duration: 3000,
            message: "The business agenda was succesfully update",
          }).present();

          this.viewCtrl.dismiss().then(() => load.dismiss());
        });
    }
  }

  public ngOnDestroy() {
    if (this.clientSubscribe) { this.clientSubscribe.unsubscribe(); }
  }

  private buildForm() {
    this.form = this.formBuilder.group({});
    this.genForm.genInputString("id", this.form);
    this.genForm.genInputDate("date", this.form, true);
    this.genForm.genInputString("hour_start", this.form, true);
    this.genForm.genInputString("hour_end", this.form, true);
    this.genForm.genInputString("location", this.form, true);
    this.genForm.genToggle("state", this.form);
    this.patchForm();
  }

  private patchForm() {
    if (this.business) {
      this.form.patchValue(this.business);
    }
    this.firstLoad = false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/interactivity/pages/business-view/components/business-agenda-form/business-agenda-form.ts